import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiButton: Components<Omit<Theme, 'components'>>['MuiButton'] = {
  defaultProps: {
    disableElevation: true,
  },
  styleOverrides: {
    root: {
      textTransform: 'none',
    },
    sizeLarge: {
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '26px',
      padding: '8px 22px',
    },
    sizeMedium: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
      padding: '6px 16px',
    },
    sizeSmall: {
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '22px',
      padding: '4px 10px 4px 10px !important',
    },
    containedPrimary: ({ theme, ownerState }) => ({
      color: theme.palette.primary.contrastText,
      background: !ownerState.disabled ? 'linear-gradient(76deg, #0D1B27 1.48%, #1E2041 60.13%, #9747FF 115.1%)' : '',
      '&:hover': {
        background: 'linear-gradient(76deg, #1A354D 1.48%, #1E2041 82.57%, #9747FF 125.99%)',
        transition: 'background 0.3s ease',
      },
      '&:active': {
        background: theme.palette.common.black,
        transition: 'none',
      },
      transition: 'color 0.3s ease',
    }),
    containedSecondary: () => ({
      color: 'black',
      background: '#ECEDEE',
      '&:hover': {
        background: '#A9ADB1',
      },
      transition: 'color 0.3s ease',
    }),
    containedInherit: ({ theme }) => ({
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      '&:hover': {
        background: theme.palette.action.focus,
      },
    }),
    outlinedPrimary: ({ theme }) => ({
      borderColor: '#0D1B273B',
      color: theme.palette.text.primary,
      padding: '7px 22px !important',
      '&:hover': {
        borderColor: '#0D1B273B',
        backgroundColor: theme.palette.action.hover,
      },
      '&:active': {
        borderColor: '#0D1B273B',
        backgroundColor: theme.palette.action.focus,
      },
    }),
    textPrimary: ({ theme }) => ({
      color: theme.palette.text.primary,
    }),
    disabled: ({ theme }) => ({
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    }),
  },
};